import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import './App.scss';
import { history } from './_helpers';
import { Nav, PrivateRoute } from './_components';
import {IdleTimeout } from './_helpers/idle';
import { Home } from './home';
import { Login } from './login';
import { Dashboard } from './TekCCReceipts/Dashboard';
import { ReimbursementDashboard } from './ExpenseReimbursement/ExpenseReimbursementDashboard';
import { UploadReceipt } from './TekCCReceipts/UploadReceipt';
import { ExpenseReimbursementUploadReceipt } from './ExpenseReimbursement/ExpenseReimbursementUploadReceipt';
import { MileageReimbursementDashboard } from './MileageReimbursement/MileageReimbursementDashboard';
import { MileageReimbursementForm } from './MileageReimbursement/MileageReimbursementForm';
import { ValidationForm } from './validationForm';
import { MissingReceiptsDashboard } from './MissingReceipts/MissingReceiptsDashboard';



export { App };

function App() {
    history.navigate = useNavigate();
    history.location = useLocation();

    return (
        <div className="app-container">
           <div className="wrapper">
           <IdleTimeout timerDuration={1800000}/>
            {/* <Nav /> */}
            <div className="">
                <Routes>
                <Route
                        path="/"
                        element={
                            <PrivateRoute>
                                <Home />
                            </PrivateRoute>
                        }
                    />
                    <Route path="/Dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                    <Route path="/ExpenseReimbursementDashboard" element={<PrivateRoute><ReimbursementDashboard /></PrivateRoute>} />
                    <Route path="/UploadReceipt" element={<PrivateRoute><UploadReceipt /></PrivateRoute>} />
                    <Route path="/ExpenseReimbursementUploadReceipt" element={<PrivateRoute><ExpenseReimbursementUploadReceipt /></PrivateRoute>} />
                    <Route path="/MileageReimbursementForm" element={<PrivateRoute><MileageReimbursementForm /></PrivateRoute>} />
                    <Route path="/MileageReimbursementDashboard" element={<PrivateRoute><MileageReimbursementDashboard /></PrivateRoute>} />
                    <Route path="/MissingReceiptsDashboard" element={<PrivateRoute><MissingReceiptsDashboard /></PrivateRoute>} />
                    <Route path="/ValidationForm" element={<PrivateRoute><ValidationForm /></PrivateRoute>} />
                    <Route path="/login" element={<Login />} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </div>
            </div>
            
        </div>
    );
}
